import COLORS from '@~/constants/colors';
import { COURSE_STATE } from '@~/constants/student-courses';

export const getRandomColor = () => {
  const RANDOM_COLORS = [
    COLORS.HEART_LIGHT,
    COLORS.SKY_DARK,
    COLORS.HEART_LIGHT,
    COLORS.GRASS,
    COLORS.HEART_DARK,
    COLORS.PRIMARY,
    COLORS.SUN,
    COLORS.SKY,
    COLORS.FLOWER_DARK,
    COLORS.GRASS_XLIGHT,
    COLORS.ORANGE,
    COLORS.ORANGE,
    COLORS.SUN,
    COLORS.GRASS,
    COLORS.HEART_XDARK,
  ];

  return RANDOM_COLORS[Math.floor(Math.random() * RANDOM_COLORS.length)];
};

export function getCookie(name) {
  const cookies = document.cookie.split('; ');

  for (let i = 0; i < cookies.length; i += 1) {
    const [key, value] = cookies[i].split('=');

    if (key === name) {
      return value;
    }
  }

  return null;
}

export function setCookie(name, value, options = {}) {
  const {
    maxAge,
    path = '/',
    secure = true,
    sameSite = 'Lax',
    domain = 'cuemath.com',
  } = options;

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  cookieString += `; Path=${path}`;

  if (maxAge !== undefined) {
    cookieString += `; Max-Age=${maxAge}`;
  }

  if (domain) {
    cookieString += `; Domain=${domain}`;
  }

  if (secure) {
    cookieString += '; Secure';
  }

  if (sameSite) {
    cookieString += `; SameSite=${sameSite}`;
  }

  document.cookie = cookieString;
}

export const isFunction = functionToCheck => {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

export const checkArrayNotEmpty = array => {
  return Array.isArray(array) && array.length > 0;
};

export const isScrollAProperty = (container, scrollBehavior = 'auto') => {
  let doesScroll = false;

  try {
    container.scroll({
      get behavior() {
        doesScroll = true;

        return scrollBehavior;
      },
    });
  } catch {
    return false;
  }

  return doesScroll;
};

const daysDiff = (firstDate, secondDate) => {
  const oneDay = 24 * 60 * 60 * 1000;

  return Math.round((secondDate - firstDate) / oneDay);
};

export const checkAndGetExpiredCoursesMessages = studentCourses => {
  const expiresMessages = [];

  if (studentCourses && Array.isArray(studentCourses) && studentCourses.length > 0) {
    const currentDate = new Date();
    const options = { year: 'numeric', month: 'long', day: 'numeric' };

    studentCourses.forEach(course => {
      if (course.state === COURSE_STATE.INACT) {
        expiresMessages.push(`${course.course_name} is expired`);
      } else if (course.validity_till_date) {
        const expiryDate = new Date(course.validity_till_date * 1000);
        const currentDaysDiffrence = daysDiff(currentDate, expiryDate);

        if (currentDaysDiffrence < 14) {
          expiresMessages.push(
            `${course.course_name} is expiring on ${expiryDate.toLocaleDateString(
              undefined,
              options,
            )}`,
          );
        }
      }
    });
  }

  return expiresMessages;
};

export function capitalizeFirstLetter(string) {
  if (!string) {
    return '';
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const setAppType = () => {
  window.CUEMATH_APP_TYPE = 'LEAP';
};

export const setPolyfills = () => {
  Number.isFinite = Number.isFinite
    ? Number.isFinite
    : value => {
        return typeof value === 'number' && isFinite(value);
      };
};

export const getStudentWelcomeMessage = () => {
  const today = new Date();
  const timeNow = today.toLocaleTimeString();
  let greetingMessage;

  if (timeNow >= '00:00:00' && timeNow < '12:00:00') {
    greetingMessage = 'Good morning';
  } else if (timeNow >= '12:00:00' && timeNow < '17:00:00') {
    greetingMessage = 'Good afternoon';
  } else if (timeNow >= '17:00:00' && timeNow < '24:00:00') {
    greetingMessage = 'Good evening';
  } else {
    greetingMessage = 'Hello,';
  }

  return greetingMessage;
};

export const setDataToLocalStorage = (storageKey, storageValue) => {
  if (!storageKey) return null;

  return localStorage.setItem(storageKey, JSON.stringify(storageValue));
};

export const getDataFromLocalStorage = storageKey => {
  if (!storageKey) return null;

  return JSON.parse(localStorage.getItem(storageKey) || `{}`);
};

export const removeDataFromLocalStorage = storageKey => {
  return localStorage.removeItem(storageKey);
};

export const getFullName = (firstName, lastName) =>
  `${firstName || ''} ${lastName || ''}`.trim();

export const getIsNextClassIn5Minutes = classTime => {
  if (!classTime) return false;

  const current = new Date().getTime();
  const classDate = new Date(classTime).getTime();

  const timeDiff = classDate - current;

  return timeDiff <= 5 * 60 * 1000 && timeDiff >= 0;
};
